import { SideEffectSchema, successSideEffectState, errorAction, loadingAction, generateConst } from ".";
// Constants
export const WorkflowConst = generateConst("WORKFLOW", ["GET_ALL_WORKFLOWS", "GET_ALL_SCRIPTS", "INIT_WORKFLOW_TEMPLATE"]);
// Schema
export interface GetWorkflowsSchema extends SideEffectSchema {
  Data?: any;
  ErrorCode?: number;
  Description?: string;
  ErrorMessage?: string;
}
export const getAllWorkflowsAction = () => {
  return {
    type: WorkflowConst.GET_ALL_WORKFLOWS,
    payload: {}
  };
};
export const getAllWorkflowsLoadingAction = () => loadingAction(WorkflowConst.GET_ALL_WORKFLOWS_LOADING);
export const getAllWorkflowsErrorAction = (error: string) => errorAction(WorkflowConst.GET_ALL_WORKFLOWS_ERROR, error);
export const getAllWorkflowsSuccessAction = (data: GetWorkflowsSchema) => {
  const payload: GetWorkflowsSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: WorkflowConst.GET_ALL_WORKFLOWS_SUCCESS,
    payload
  };
};

export interface GetScriptsSchema extends SideEffectSchema {
  Data?: any;
  ErrorCode?: number;
  Description?: string;
  ErrorMessage?: string;
}
export const getAllScriptsAction = () => {
  return {
    type: WorkflowConst.GET_ALL_SCRIPTS,
    payload: {}
  };
};
export const getAllScriptsLoadingAction = () => loadingAction(WorkflowConst.GET_ALL_SCRIPTS_LOADING);
export const getAllScriptsErrorAction = (error: string) => errorAction(WorkflowConst.GET_ALL_SCRIPTS_ERROR, error);
export const getAllScriptsSuccessAction = (data: GetScriptsSchema) => {
  const payload: GetScriptsSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: WorkflowConst.GET_ALL_SCRIPTS_SUCCESS,
    payload
  };
};

export const initWorkflowTemplateJSONAction = () => {
  return {
    type: WorkflowConst.INIT_WORKFLOW_TEMPLATE,
    payload: {}
  };
};

export const initWorkflowTemplateJSONSuccessAction = (data: any) => {
  const payload: any = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: WorkflowConst.INIT_WORKFLOW_TEMPLATE_SUCCESS,
    payload
  };
};
